module.exports = __webpack_public_path__ + "static/media/moscow-conservatory.21ea544d.jpg";